module.exports = __webpack_public_path__ + "img/dewu.b2774c99.png";